import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

/** The "Tycho" home link. The clay dot is decoration; the link's name stays "Tycho". */
export function Wordmark({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={cn("flex items-center gap-2 font-medium font-serif text-lg", className)}
    >
      <span aria-hidden className="size-2 rounded-full bg-accent" />
      Tycho
    </Link>
  );
}
